import { useAuthStore } from './store';
import { hasAnyPermissionIn, hasPermissionIn } from './access';

/* Решение guard'а сервера (`RequirePermission<P>`) на стороне интерфейса — по
   `permission_codes` из `/v1/me` в сторе: полный доступ пропускает всё, иначе точное
   совпадение. Удобство, а не граница: сервер перепроверяет каждое действие сам. Коды прав —
   `PERM` в `./access`. */

export function hasPermission(codes: string[] | null | undefined, permission: string): boolean {
  return hasPermissionIn(codes, permission);
}

export function hasAnyPermission(
  codes: string[] | null | undefined,
  anyOf: ReadonlyArray<string>,
): boolean {
  return hasAnyPermissionIn(codes, anyOf);
}

/** Reactive: re-evaluates whenever the store's `user.permission_codes` changes
 *  (e.g. after a live SSE-triggered `/v1/me` re-fetch — see useLivePermissionSync). */
export function usePermission(permission: string): boolean {
  return useAuthStore((s) => hasPermissionIn(s.user?.permission_codes, permission));
}

/** Любое из прав — реактивно, как `usePermission`. */
export function useAnyPermission(anyOf: ReadonlyArray<string>): boolean {
  return useAuthStore((s) => hasAnyPermissionIn(s.user?.permission_codes, anyOf));
}

const NO_CODES: string[] = [];

/** Все коды текущего пользователя — для превью и составных условий. Пустой массив один и тот
 *  же, иначе селектор выдавал бы новый объект на каждый рендер. */
export function usePermissionCodes(): string[] {
  return useAuthStore((s) => s.user?.permission_codes ?? NO_CODES);
}
